module.exports = __webpack_public_path__ + "static/media/screenshot_history_5_en.0f0261cc.png";